export default __webpack_public_path__ + "static/media/oppslag.0e5d7096.jpg";